import React, { ReactElement } from 'react';
import Dialog from '@mui/material/Dialog';
import ContentHeader from '../content-header/content-header.component';
import ModalTransition from '../modal-transition/modal-transition.component';
import FormatService from '../../services/format-service';
import useScreenMobile from '../../hooks/use-screen-mobile';
import useStylesModalLayout from './modal-layout.styles';

const ModalLayout: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const CLASSNAME_MODAL_LAYOUT: string = 'modal-layout';

  const {
    isOpen,
    isLarge,
    isMedium,
    isSubModal,
    isModalEditMode,
    withNoHeader,
    withEditModeSwitcher,
    title,
    editPermission,
    onCloseModal,
    onCloseModalByClickAway,
    onSwitchModalEditMode,
    imageComponent,
    children,
  } = props;

  const { classes } = useStylesModalLayout();
  const isMobileScreen: boolean = useScreenMobile();

  const largeClassName: string | undefined = isLarge ? classes.modalLayoutLarge : undefined;
  const mediumClassName: string | undefined = isMedium ? classes.modalLayoutMedium : undefined;
  const subModalClassName: string | undefined = isSubModal ? classes.modalLayoutSubModal : undefined;

  return (
    <div>
      {
        isOpen && (
          <Dialog
            open={isOpen}
            fullScreen={isMobileScreen}
            closeAfterTransition={false}
            className={CLASSNAME_MODAL_LAYOUT}
            classes={{
              paper: FormatService.formatClassNames(
                classes.modalLayout, largeClassName, mediumClassName, subModalClassName,
              ),
            }}
            onClose={onCloseModalByClickAway || onCloseModal}
            TransitionComponent={ModalTransition}
          >
            {
              !withNoHeader && (
                <ContentHeader
                  isModal
                  isEditMode={isModalEditMode}
                  withEditModeSwitcher={withEditModeSwitcher}
                  title={title}
                  editPermission={editPermission}
                  onCloseModal={onCloseModal}
                  onSwitchModalEditMode={onSwitchModalEditMode}
                  imageComponent={imageComponent}
                />
              )
            }
            <div>
              {children}
            </div>
          </Dialog>
        )
      }
    </div>
  );
});

export default ModalLayout;
